import product from "./product";

export default {
    product,

    noAvailableItems: "No products available to order."
}